import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { BetManager, Logger, useBetslipStateUpdate } from '@atlas/core';
import { Label, Loader } from '@atlas/ui';

const GetMaxBetButton = ({
  betItems,
  className = '',
  disabled,
  loadingBtnMax,
  selectedBet,
  setBetAmount,
}) => {
  const betslipStateUpdate = useBetslipStateUpdate();

  const handleGetMaxBet = useCallback(async () => {
    try {
      betslipStateUpdate({ loading: true });
      const limits = await BetManager.getMaxBet(selectedBet);

      setBetAmount(limits.finalMaxBetLimit);
    } catch (error) {
      Logger.info('unable to resolve max bet', error);
    } finally {
      betslipStateUpdate({ loading: false });
    }
  }, [selectedBet, setBetAmount, betslipStateUpdate]);

  const buttonClassNmae = cx('betslip-controls-money__max', className);

  return (
    <button
      className={buttonClassNmae}
      disabled={disabled || loadingBtnMax}
      onClick={handleGetMaxBet}
    >
      {loadingBtnMax ? <Loader /> : <Label message="max_bet" />}
    </button>
  );
};

GetMaxBetButton.propTypes = {
  betItems: PropTypes.array.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  selectedBet: PropTypes.object.isRequired,
  setBetAmount: PropTypes.func.isRequired,
};

export default GetMaxBetButton;
